import httpClient from './httpClient'
import _ from 'lodash'

const END_POINT = '/api/grupos'

const getByCurso = async (idCurso, idLocalizacion) => {
    let params = {
        "order[nivel.descripcion]": "asc",
        "order[dia.descripcion]": "asc",
        "order[horario.descripcion]": "asc",
        curso: idCurso,
        pagination: false
    }

    if (0 !== idLocalizacion) {
        params.localizacion = idLocalizacion
    }

    return await httpClient.get(END_POINT, { params })
}

const addGrupo = async (item) => {
    if ( _.isNil(item.curso)) {
        throw new Error('No es posible añadir el grupo, el curso es nulo.')
    }

    let grupo = _.cloneDeep(item)

    grupo.localizacion = grupo.localizacion.id

    // parse plazas, grupos e importe
    grupo.plazas = (!_.isNil(grupo.plazas)) ? parseInt(grupo.plazas) : grupo.plazas
    grupo.grupos = (!_.isNil(grupo.grupos)) ? parseInt(grupo.grupos) : grupo.grupos
    grupo.importe = (!_.isNil(grupo.importe)) ? parseFloat(grupo.importe) : grupo.importe

    return await httpClient.post(END_POINT, grupo)
}

const update = async (item) => {

    let idGrupo = item.id || null

    if (idGrupo == null) {
        throw new Error('No es posible actualizar el grupo, ID es nulo.')
    }

    const params = {
        aula: (_.isNil(item.aula) || _.isEmpty(item.aula)) ? null : item.aula.id,
        grupos: (_.isNil(item.grupos) || _.isEmpty(item.grupos)) ? null : parseInt(item.grupos),
    }

    return await httpClient.put(`${END_POINT}/${idGrupo}`, { ...params })

}

const remove = async (item) => {

    let idGrupo = item.id || null

    if (idGrupo == null) {
        throw new Error('No es posible borrar el grupo, el identificador es nulo.')
    }

    return await httpClient.delete(`${END_POINT}/${idGrupo}`)
}

/**
 * Accion de duplicar grupos.
 *
 * Genera los grupos del año actual duplicando los del año anterior sin duplicidades (nivel, dia, horario).
 * No es necesario pasarle el curso como parametro, se encarga el backend, lo obtiene de base de datos.
 */
const duplicar = async () => {
    return await httpClient.get(`${END_POINT}/duplicar`)
}


const crearAulas = async () => {
    return await httpClient.get(`${END_POINT}/crear-aulas`)
}

export {

    getByCurso,
    update,
    addGrupo,
    remove,
    duplicar,
    crearAulas

}